export default {
  title: 'Webhook signing secret',
  warning: 'Store this secret now — it will not be shown again. Use it to verify the X-Webhook-Signature header.',
  done: 'Done',
};
